import {Icon, IconProps} from '@chakra-ui/react';

export function MarketIcon({active, ...props}: IconProps & {active: boolean}) {
  return (
    <Icon width="17px" height="17px" viewBox="0 0 17 17" fill="none" color={active ? '#C4E0E5' : 'gray'} {...props}>
      <mask id="path-1-inside-1_537_1194" fill="white">
        <path d="M15.22 8.5V13.5C15.22 14.9667 14.068 16.1667 12.66 16.1667H4.34003C2.93203 16.1667 1.78003 14.9667 1.78003 13.5V8.5" />
      </mask>
      <path
        d="M14.22 8.5V13.5H16.22V8.5H14.22ZM14.22 13.5C14.22 14.4532 13.4777 15.1667 12.66 15.1667V17.1667C14.6584 17.1667 16.22 15.4801 16.22 13.5H14.22ZM12.66 15.1667H4.34003V17.1667H12.66V15.1667ZM4.34003 15.1667C3.5224 15.1667 2.78003 14.4532 2.78003 13.5H0.780029C0.780029 15.4801 2.34166 17.1667 4.34003 17.1667V15.1667ZM2.78003 13.5V8.5H0.780029V13.5H2.78003Z"
        fill="currentColor"
        mask="url(#path-1-inside-1_537_1194)"
      />
      <path
        d="M12.3401 6.83325H11.5901C11.5901 7.54819 11.0333 8.08325 10.4201 8.08325C9.80684 8.08325 9.25007 7.54819 9.25007 6.83325H8.50007H7.75007C7.75007 7.54819 7.19329 8.08325 6.58007 8.08325C5.96684 8.08325 5.41007 7.54819 5.41007 6.83325H4.66007H3.91007C3.91007 7.54819 3.35329 8.08325 2.74007 8.08325C2.13599 8.08325 1.58669 7.56403 1.57044 6.86512C1.57223 6.85303 1.57602 6.8276 1.58352 6.78437C1.59788 6.7016 1.61964 6.58663 1.64809 6.44299C1.70478 6.15674 1.78484 5.77276 1.87741 5.33837C2.06237 4.47046 2.29482 3.41265 2.48422 2.55765C2.61027 1.98864 3.11553 1.58325 3.70075 1.58325H13.2994C13.8846 1.58325 14.3899 1.98864 14.5159 2.55765C14.7053 3.41265 14.9378 4.47046 15.1227 5.33837C15.2153 5.77276 15.2954 6.15674 15.352 6.44299C15.3805 6.58663 15.4023 6.7016 15.4166 6.78437C15.4241 6.8276 15.4279 6.85303 15.4297 6.86511C15.4134 7.56403 14.8641 8.08325 14.2601 8.08325C13.6468 8.08325 13.0901 7.54819 13.0901 6.83325H12.3401Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M9.27997 13.4465V15.6665H7.71997V13.4465C7.71997 13.0157 8.06919 12.6665 8.49997 12.6665C8.93075 12.6665 9.27997 13.0157 9.27997 13.4465Z"
        stroke="currentColor"
        strokeMiterlimit="10"
      />
    </Icon>
  );
}
